<div class="audio-controls-container">
  <div class="global-controls">
    <label for="volume">Global Volume:</label>
    <input
      type="range"
      id="volume"
      min="0"
      max="1"
      step="0.01"
      [value]="volume"
      (input)="onVolumeChange($event)" />
    <span>{{ (volume * 100).toFixed(0) }}%</span>
    <slotcom-button
      class="c-button--pink audio"
      (safeClick)="toggleMute()"
      [isDisabled]="isBGMMuted || isSFXMuted">
      {{ isAllMuted ? 'Unmute All' : 'Mute All' }}
    </slotcom-button>
    <slotcom-button
      class="c-button--pink audio"
      (safeClick)="toggleMuteForType('BGM')"
      [isDisabled]="isAllMuted">
      {{ isBGMMuted ? 'Unmute BGM' : 'Mute BGM' }}
    </slotcom-button>
    <slotcom-button
      class="c-button--pink audio"
      (safeClick)="toggleMuteForType('SFX')"
      [isDisabled]="isAllMuted">
      {{ isSFXMuted ? 'Unmute SFX' : 'Mute SFX' }}
    </slotcom-button>
  </div>

  <hr />

  <h4 [style.text-align]="'center'">App Audio Files:</h4>
  <ul class="audio-list">
    @for (audio of SOUND_LIBRARY_ENTRIES; track audio) {
      <li [ngClass]="getAudioStateClass(audio.id)">
        <strong>{{ audio.type }} - {{ audio.id }}</strong>
        <span class="state-indicator">State: {{ audioStates[audio.id] || 'N/A' }}</span>
        <div class="audio-actions">
          <slotcom-button
            class="c-button--pink audio"
            (safeClick)="playAudio(audio.id)"
            [isDisabled]="audioStates[audio.id] === 'playing' || audioStates[audio.id] === 'loading'">
            Play
          </slotcom-button>
          <slotcom-button
            class="c-button--pink audio"
            (safeClick)="pauseAudio(audio.id)"
            [isDisabled]="audioStates[audio.id] !== 'playing'">
            Pause
          </slotcom-button>
          <slotcom-button
            class="c-button--pink audio"
            (safeClick)="stopAudio(audio.id)"
            [isDisabled]="
              audioStates[audio.id] === 'idle' ||
              audioStates[audio.id] === 'ended' ||
              audioStates[audio.id] === 'loading'
            ">
            Stop
          </slotcom-button>
          <label class="checkbox-container audio c-loop-label-wrapper">
            <input
              type="checkbox"
              [checked]="isLooping(audio.id)"
              (change)="toggleLoop(audio.id)"
              [disabled]="audioStates[audio.id] === 'playing' || audioStates[audio.id] === 'loading'"
              class="c-loop-checkbox" />
            Loop
          </label>
        </div>
      </li>
    }
  </ul>
</div>
